export const isEnglishChatMessage = (message: string): boolean => /^[A-Za-z\p{N}\p{P}\p{S}\p{Z}\s]*$/u.test(message);
